import { SystemIcon } from '@storeblocks/icon';
import styled from 'styled-components';

export const WaitingIcon = styled(SystemIcon).attrs(() => ({
  name: 'time',
  size: 16,
  isPhosphor: true,
}))`
  color: var(--on-background);
`;
